import {ApiClientService, EntityApiService} from '@dofleini/security';
import {API_CMS} from '../constants/api.settings';
import {PAGE_STATUS} from '../constants/pages';


class BlockCategoryApiService extends EntityApiService {

  getPageBySlug = (slug, config) => {
    return ApiClientService.get(this.getPath('/slug', null) + slug, config).then(({data}) => data);
  };

  existSlug = (slug, config) => {
    return ApiClientService.get(this.getPath('/exist/slug/', null) + slug, config).then(({data}) => data);
  };

  save = (params, config) => {
    if (params._id)
      return this.update(params._id, params, config);

    return ApiClientService.post(this.getPath(null, params), params, config);
  };

  publish = (params, config) => {
    return this.update(params._id, {status: PAGE_STATUS.PUBLISH}, config);
  };

  draft = (params, config) => {
    return this.update(params._id, {status: PAGE_STATUS.DRAFT}, config);
  };

  rename = (params, config) => {
    return this.update(params._id, {title: params.title}, config);
  };

}

export default new BlockCategoryApiService(`${API_CMS.url}/pages`);
